/* eslint no-console:0 */
// esbuild が app/legacy/CSS をバンドルするエントリ (#2463)。propshaft が
// app/assets/builds を digest し /statics から配信する。

import { Turbo } from '@hotwired/turbo-rails';
import axios from 'axios';
import './controllers';
// Bootstrap JS only (CSS comes from the sass bundle)
import * as bootstrap from 'bootstrap';
// BS5 の data-API を確定的に配線する(tree-shaking で失われる副作用の代替)。
// jQuery 撤去 (#2428) で data-bs-toggle/dismiss が沈黙した回帰への対処。
import './bootstrap_data_api';
import mountReact from './mount_react';

// react_component ヘルパが吐いた data-react-class ノードへ React 島をマウントし、
// Turbo ナビゲーションにも追従させる。
mountReact();

// Maintain a window-level counter of in-flight axios requests so RSpec system
// specs can poll `window.axiosPendingRequests` from `wait_for_ajax` and reliably
// wait for XHR completion (Capybara's default polling has no XHR awareness).
window.axiosPendingRequests = 0;
axios.interceptors.request.use((config) => {
  window.axiosPendingRequests = (window.axiosPendingRequests || 0) + 1;
  return config;
}, (error) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return Promise.reject(error);
});
axios.interceptors.response.use((response) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return response;
}, (error) => {
  window.axiosPendingRequests = Math.max(0, (window.axiosPendingRequests || 0) - 1);
  return Promise.reject(error);
});

Turbo.session.drive = false;
window.Turbo = Turbo;
// Expose Bootstrap globally so RSpec system specs can poll
// `window.bootstrap` to know that the BS5 ESM bundle has finished
// executing and `data-bs-toggle="modal"` click handlers are ready.
// Without this signal, Capybara can click a modal-trigger before
// Bootstrap binds, and the click is silently dropped.
window.bootstrap = bootstrap;
